/* Sale events: fills and switches every event spot (hero, announcement, nav, card badges, prices, product offer
   line, cart + bag drawer) on and off at the event's start and end times, decided in the shopper's browser so it
   works with cached pages. The active event is chosen by the small inline script in theme.liquid (window.RBEV);
   the event list lives in snippets/rb-events-data.liquid. Prices shown are display only: the real price, the add
   to bag value and the checkout discount are never changed here. */
(() => {
  const R = window.RBEV; if (!R) return;
  const root = document.documentElement;
  const now = () => (R.now ? R.now() : Date.now());
  let ev = R.event;
  const pick = (v) => (R.text ? R.text(v) : v == null ? '' : typeof v === 'string' || typeof v === 'number' ? String(v) : (v[R.country] ?? v.default ?? ''));
  const money = (c) => (window.RBUI && window.RBUI.money ? window.RBUI.money(c) : '$' + (c / 100).toFixed(2));
  const pct = () => Number(ev && ev.percent_off) || 0;
  // Same as Shopify's automatic percentage discount: the discount is the percentage of the price rounded DOWN to the
  // cent (checked in a real cart 2026-10-01: $94.79 gives $9.47 off, $85.32), then taken off the price.
  const cut = (c) => { c = Math.round(Number(c)); return c - Math.floor(c * pct() / 100); };
  const two = (n) => String(n).padStart(2, '0');
  // Event price for one variant (cents), shared with rb-product.js so the PreOrder Globo button it relabels shows the
  // same price as the Add to bag button. Shopify's event discount covers every size of a sale collection product,
  // marked down sizes too (their market price is raised for the event so it lands on the usual markdown price), so
  // every size gets the event price here as well.
  R.salePrice = (c) => (ev && pct() > 0 && !(pdpData && pdpData.eventEligible === false) ? cut(c) : Math.round(Number(c)));
  const pdpData = (() => { try { return JSON.parse(document.getElementById('rbProductData').textContent); } catch (e) { return null; } })();

  function countdown() {
    if (!ev) return '';
    const left = Date.parse(ev.end) - now(), h = Number(ev.countdown_hours) || 0;
    if (!h || left <= 0 || left > h * 3600e3) return '';
    const m = Math.floor(left / 60000), d = Math.floor(m / 1440);
    const frl = /^fr/i.test(root.getAttribute('lang') || '');
    return (frl ? 'Se termine dans ' + (d ? d + 'j ' : '') : 'Ends in ' + (d ? d + 'd ' : '')) + two(Math.floor((m % 1440) / 60)) + 'h ' + two(m % 60) + 'm';
  }

  // Price cells: remember what the theme wrote, show the event price while active, put the theme's own back after.
  const orig = new WeakMap(), wrote = new WeakMap();
  const norm = document.createElement('div');
  function paint(el, html) {
    if (el.innerHTML !== wrote.get(el)) orig.set(el, el.innerHTML);
    if (html == null) { if (orig.has(el) && el.innerHTML === wrote.get(el)) el.innerHTML = orig.get(el); wrote.delete(el); return; }
    // Compare in the browser's own spelling: French prices use a no-break space, which innerHTML reads back as
    // &nbsp;, so a raw string never matches and the price would be rewritten (and the page watcher woken) forever.
    norm.innerHTML = html; html = norm.innerHTML;
    if (el.innerHTML !== html) el.innerHTML = html;
    wrote.set(el, el.innerHTML);
  }

  // Rug pad offers (product page line and the bag's pad cards): show the event price (every pad size gets it).
  function padPrices(on) {
    const pad = window.RBCFG && window.RBCFG.pad; if (!pad || !pad.variants) return;
    const line = document.getElementById('padLine');
    if (line) pad.variants.forEach((v) => {
      const a = money(v.price), b = money(cut(v.price)), t = line.textContent;
      if (on && t.includes(' ' + a + ' ')) line.textContent = t.replace(' ' + a + ' ', ' ' + b + ' ');
      else if (!on && a !== b && t.includes(' ' + b + ' ')) line.textContent = t.replace(' ' + b + ' ', ' ' + a + ' ');
    });
    document.querySelectorAll('[data-pad-add]').forEach((btn) => {
      const v = pad.variants.find((x) => String(x.id) === String(btn.dataset.padAdd)); if (!v) return;
      const n = btn.querySelector('.num'); if (!n) return;
      const q = Number(btn.dataset.padQty) || 1, want = money((on ? cut(v.price) : Number(v.price)) * q);
      if (n.textContent !== want) n.textContent = want;
    });
  }

  function prices() {
    const on = ev && pct() > 0;
    document.querySelectorAll('[data-rbev-min]').forEach((el) => {
      if (!on) return paint(el, null);
      // rbevWas: the cheapest size's own was price when it is marked down, so the struck price stays like-for-like
      const min = Number(el.dataset.rbevMin), max = Number(el.dataset.rbevMax || 0), was = Number(el.dataset.rbevWas || 0);
      const top = max > min ? cut(max) : 0;
      paint(el, `<s>${money(was > min ? was : min)}</s> <span class="now is-sale">${money(cut(min))}</span>` +
        (top > cut(min) ? `<span class="range"> – ${money(top)}</span>` : ''));
    });
    // product page: the sale only shows when the product is in the sale collection (rbProductData.eventEligible)
    const pon = on && !(pdpData && pdpData.eventEligible === false);
    const pp = pdpData && document.getElementById('price');
    if (pp) {
      const vid = (document.getElementById('rbVariantId') || {}).value;
      const v = pdpData.variants.find((x) => String(x.id) === String(vid)) || pdpData.variants[0];
      // a marked down size keeps its own was price as the struck price
      const was = v && v.compare > v.price ? v.compare : v && v.price;
      const applied = document.querySelector('[data-rbev-applied]');
      if (applied) { const t = pon ? pick(ev.applied_line) || `${pct()}% off at checkout` : ''; if (applied.textContent !== t) applied.textContent = t; }
      paint(pp, pon && v ? `<s>${money(was)}</s><span class="now is-sale">${money(cut(v.price))}</span>` : null);
      // Add to bag button: show the event price too (display only; the cart still adds the real variant)
      const add = document.getElementById('rbAdd');
      // PreOrder Globo swaps in its own button on pre-order sizes; same display rule as the Add to bag button
      if (v && v.available) document.querySelectorAll('.buy-row .gPreorderBtn').forEach((b) => {
        const full = money(v.price), sale = money(cut(v.price)), t = b.textContent.trim();
        if (pon && t.endsWith(full) && sale !== full) b.textContent = t.slice(0, t.length - full.length) + sale;
        else if (!pon) backToFull(b, full);
      });
      if (add && v && v.available) {
        const full = money(v.price), sale = money(cut(v.price)), t = add.textContent;
        if (pon && t.endsWith(full)) add.textContent = t.slice(0, t.length - full.length) + sale;
        else if (!pon) backToFull(add, full);
      }
    }
    padPrices(on);
    sizeBadges(pon);
  }

  // Size chips: during an event, every in-stock full price size gets the event percentage ("−10%") in the same badge
  // the theme uses for marked down sizes (rb-product.js). Marked down sizes keep their own badge, showing the whole
  // saving from their was price to the event price (put back to the theme's own figure when the event ends), sold out
  // sizes get none, and the event badges go away by themselves when the event ends.
  // When the event ends with the page open, the percentage is already 0, so the old event price can't be worked out
  // again: put the full price back after the button's " · " instead of matching the old price.
  function backToFull(btn, full) {
    const t = btn.textContent.trim(), i = t.lastIndexOf(' · ');
    if (i > -1 && t.slice(i + 3) !== full) btn.textContent = t.slice(0, i + 3) + full;
  }

  function sizeBadges(on) {
    if (!pdpData) return;
    const groups = document.querySelectorAll('[data-option]');
    if (groups.length !== 1 || !groups[0].hasAttribute('data-size-option')) return;
    groups[0].querySelectorAll('.size').forEach((b) => {
      const v = pdpData.variants.find((x) => x.options[0] === b.dataset.value);
      const own = b.querySelector('.size-off:not(.rbev-off)');
      if (own && v && v.compare > v.price) {
        // same rounding as rb-product.js's own badge
        const t = '−' + Math.round((1 - (on ? cut(v.price) : v.price) / v.compare) * 100) + '%';
        if (own.textContent !== t) own.textContent = t;
      }
      const want = on && v && v.available && !(v.compare > v.price) && !own;
      let tag = b.querySelector('.rbev-off');
      if (want) {
        if (!tag) { tag = document.createElement('span'); tag.className = 'size-off rbev-off'; tag.setAttribute('aria-hidden', 'true'); b.appendChild(tag); }
        const t = '\u2212' + pct() + '%'; if (tag.textContent !== t) tag.textContent = t;
        if (!b.classList.contains('rbev-sale')) b.classList.add('rbev-sale');
      } else {
        if (tag) tag.remove();
        if (b.classList.contains('rbev-sale')) b.classList.remove('rbev-sale');
      }
    });
  }

  function fill() {
    const cd = countdown();
    if (ev) document.querySelectorAll('[data-rbev-text]').forEach((el) => { const t = pick(ev[el.dataset.rbevText]); if (el.textContent !== t) el.textContent = t; });
    document.querySelectorAll('[data-rbev-href]').forEach((el) => { const u = pick(ev && ev[el.dataset.rbevHref]); if (u) el.setAttribute('href', u); });
    document.querySelectorAll('[data-rbev-countdown]').forEach((el) => { if (el.textContent !== cd) el.textContent = cd; });
    document.querySelectorAll('[data-rbev-cartline]').forEach((el) => { const t = ev && pct() && fullInCart ? pick(ev.nav_label) + ': ' + pick(ev.applied_line) : ''; if (el.textContent !== t) el.textContent = t; });
    if (ev) { hero(); feature(); }
    prices();
  }

  // Event hero photo, for an event that starts while the page is open (the inline script under the hero section
  // fills it on load).
  function hero() {
    document.querySelectorAll('.rbev-hero').forEach((sec) => {
      const img = sec.querySelector('img'), src = sec.querySelector('source');
      if (!img || img.getAttribute('src')) return;
      const set = (u) => [640, 960, 1280, 1600, 2000, 2400].map((w) => `${u}${u.includes('?') ? '&' : '?'}width=${w} ${w}w`).join(', ');
      const d = pick(ev.hero_desktop_image), m = pick(ev.hero_mobile_image) || d;
      if (d) { img.srcset = set(d); img.src = `${d}${d.includes('?') ? '&' : '?'}width=1600`; if (src) src.srcset = set(m); }
      else if (sec.dataset.fallbackD) { img.src = sec.dataset.fallbackD; if (src) src.srcset = sec.dataset.fallbackM; }
      img.alt = pick(ev.hero_alt);
      if (ev.hero_desktop_focus) sec.style.setProperty('--rbev-focus', pick(ev.hero_desktop_focus));
      if (ev.hero_mobile_focus) sec.style.setProperty('--rbev-focus-m', pick(ev.hero_mobile_focus));
    });
  }

  // Collection grid sale feature photo.
  function feature() {
    document.querySelectorAll('.rbev-feature img').forEach((img) => {
      if (img.getAttribute('src')) return;
      const u = pick(ev.feature_image) || pick(ev.hero_desktop_image); if (!u) return;
      const q = u.includes('?') ? '&' : '?';
      img.srcset = [600, 900, 1200, 1400, 1800].map((w) => `${u}${q}width=${w} ${w}w`).join(', ');
      img.src = `${u}${q}width=1200`; img.alt = pick(ev.hero_alt);
      if (ev.feature_focus) img.style.objectPosition = pick(ev.feature_focus);
    });
  }

  // Cart page + bag: the "applied automatically" line shows only when Shopify actually discounted something in the
  // bag (bedding and other non-sale items get nothing).
  let fullInCart = false, cartSig = null, cartBusy = false, cartAgain = false;
  const prodCache = new Map();
  const rootUrl = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  async function checkCart() {
    if (!ev || !pct() || !document.querySelector('[data-rbev-cartline]')) return;
    if (cartBusy) { cartAgain = true; return; }
    cartBusy = true;
    try {
      const cart = await (await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const sig = (cart.items || []).map((i) => i.variant_id + 'x' + i.quantity).join(',');
      if (sig !== cartSig) {
        // the "applied automatically" line follows what Shopify actually discounted in this cart
        const full = (cart.items || []).some((i) => (i.line_level_discount_allocations || []).some((d) => d.amount > 0));
        cartSig = sig; fullInCart = full; fill();
      }
    } catch (e) {} finally { cartBusy = false; if (cartAgain) { cartAgain = false; checkCart(); } }
  }

  // Watch for cards added later (infinite scroll, filters) and for the product page rewriting its price.
  let queued = false, mo = null;
  const soon = (recs) => {
    if (recs && recs.some((r) => r.target.closest && r.target.closest('#bagBody, .cart-page'))) checkCart();
    if (queued) return; queued = true;
    // rAF is held back in background tabs and on some phones, so a timer runs it too; whichever comes first wins
    const run = () => { if (!queued) return; queued = false; if (ev) prices(); };
    requestAnimationFrame(run); setTimeout(run, 60);
  };
  // Size change: the product page writes the new price right after it updates the variant input, so repaint just
  // after that (and once more a moment later) instead of relying only on the page watcher.
  document.addEventListener('change', (e) => {
    if (!e.target || e.target.id !== 'rbVariantId' || !ev) return;
    setTimeout(prices, 0); setTimeout(prices, 250);
  }, true);
  function watch() {
    if (ev && !mo) { mo = new MutationObserver(soon); mo.observe(document.body, { childList: true, subtree: true }); }
    if (!ev && mo) { mo.disconnect(); mo = null; }
  }

  function apply() {
    root.classList.toggle('rbev', !!ev);
    if (ev) root.setAttribute('data-rbev', ev.id); else root.removeAttribute('data-rbev');
    fill(); watch(); checkCart();
  }

  // Turn on or off by itself when the start or end time passes while the page is open; keep the countdown fresh.
  setInterval(() => {
    const next = R.pick(now());
    if ((next && next.id) !== (ev && ev.id)) { ev = next; R.event = next; apply(); }
    else if (ev) fill();
  }, 20000);

  apply();
})();
